import { UserEntity } from "@citychallenge/api-public";
import { PermissionService } from "../permission";
import { ServiceInterface } from "../service.interface";
import { UserService } from "../user";
import { IReactionDisposer, reaction, computed } from "mobx";
import { createContext } from "react";
import { PushAdapterInterface } from "./push-adapter.interface";

export const PushServiceContext = createContext<PushService>(null as any);

export class PushService implements ServiceInterface {
  public context = PushServiceContext;

  constructor(
    private permissionService: PermissionService,
    private userService: UserService,
    private pushAdapter?: PushAdapterInterface
  ) {}

  private disposers: IReactionDisposer[] = [];

  public serviceWillMount() {
    this.pushAdapter?.serviceWillMount(this.handleUrl);

    this.disposers.push(
      reaction(() => this.userService.user, this.loginStateChanged, {
        fireImmediately: true,
      })
    );

    this.disposers.push(
      reaction(
        () => this.userService.visibleNickname,
        this.visibleNicknameChanged,
        {
          fireImmediately: true,
        }
      )
    );
  }

  private handleUrl = (_url: string) => {
    //
  };

  /**
   * Every time the login state changes to true
   * @param state Active user or undefined
   */
  private loginStateChanged = (user?: UserEntity) => {
    if (user) this.pushAdapter?.setUserId(user.id);
  };

  /**
   * Every time the users nickname changed we want to sync to to onesignal
   * for personalized push notifications
   */
  private visibleNicknameChanged = (nickname?: string) => {
    if (nickname) this.pushAdapter?.setNickname(nickname);
  };

  public serviceWillUnmount() {
    for (const disposer of this.disposers) disposer();
  }

  /**
   * Check if permission for notifications has been granted
   */
  @computed
  public get hasPermission() {
    return this.permissionService.notification === "granted";
  }
}
